import { useEffect, useState } from "react";

const CONSENT_KEY = "cookie_consent_status";

function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem(CONSENT_KEY);
    if (!savedConsent) {
      setIsVisible(true);
    }
  }, []);

  const saveConsent = (status) => {
    const maxAge = 60 * 60 * 24 * 180; // 180 days
    localStorage.setItem(CONSENT_KEY, status);
    document.cookie = `cookie_consent=${status}; max-age=${maxAge}; path=/; SameSite=Lax`;
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <section className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <p>
        We use cookies to improve site performance and user experience. You can
        accept or reject non-essential cookies.
      </p>
      <div className="cookie-actions">
        <button
          type="button"
          className="secondary-btn cookie-btn"
          onClick={() => saveConsent("rejected")}
        >
          Reject
        </button>
        <button
          type="button"
          className="primary-btn cookie-btn"
          onClick={() => saveConsent("accepted")}
        >
          Accept
        </button>
      </div>
    </section>
  );
}

export default CookieConsentBanner;
